<template>
    <form class="form-horizontal" v-if="config">
        <div class="form-group">
            <label for="tempo_desligado" class="col-sm-2 control-label">TEMPO PARADO (min):</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.tempo_desligado" class="form-control input-sm" id="tempo_desligado">
            </div>
            <label for="tempo_ligado" class="col-sm-2 control-label">TEMPO DIRIGINDO (seg):</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.tempo_ligado"  class="form-control" id="tempo_ligado" >
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-4">
                <button @click="send()" type="button" class="btn btn-xs btn-success">
                    <i class="fa fa-save"></i> ENVIAR CONFIGURAÇÃO
                </button>
            </div>
            <div class="col-sm-4">

            </div>
            <div class="col-sm-2">

                <div class="dropup">
                    <button class="btn btn-xs btn-block btn-default dropdown-toggle" type="button" id="dropdownMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                        <i class="fa fa-list-alt"></i> AÇÕES
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuList">
                        <li>
                            <button @click="sendAll()" type="button" class="btn btn-xs btn-success">
                                <i class="fa fa-save"></i> ENVIAR COMANDOS PARA TODOS
                            </button>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </form>
</template>
<script>
    import {Tk} from '../../../../class/tk';
    import {Bus} from '../../../../class/bus';
    export default {
        name: "TempoTk",
        props: {
            config: {
                default: null
            }
        },
        methods: {
            send () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Tk.sendTempos(this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            },
            sendAll () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração para todos?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Tk.sendTemposAll(this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            }
        }
    }
</script>
